import React, { FC } from "react";
import { IJsonForm } from "@cayo/shared/api/types/schema";
import FullScreenModal from "./FullScreenModal";
import { GridContainer } from "../GridContainer/GridContainer";

type ReportDialogProps = { scheme: IJsonForm; onClose: () => void };

const ReportDialog: FC<ReportDialogProps> = ({ scheme, onClose }) => {
  return (
    <div>
      <FullScreenModal title={scheme.title!} isOpen={true} onDismiss={onClose}>
        <GridContainer scheme={scheme.items![0]} propertyAnnotations={[]} gridSettingsKey={"ddd"} />
      </FullScreenModal>
    </div>
  );
};

export default ReportDialog;
